'use client';
import React from 'react';
import LazyLoad from 'react-lazyload';
import styled from '@benzinga/themetron';
import type { DeviceType } from '@benzinga/device-utils';
import { AD_RESERVED_CLASS } from '@benzinga/ads-utils';
import { useBenzingaEdge } from '@benzinga/edge';

const ConnatixVideoPlayer = React.lazy(() =>
  import('@benzinga/ads/connatix').then(module => {
    return { default: module.ConnatixVideoPlayer };
  }),
);

const ConnatixInitialHeadScript = React.lazy(() =>
  import('@benzinga/ads/connatix').then(module => {
    return { default: module.ConnatixInitialHeadScript };
  }),
);

interface ConnatixVideoProps {
  attrs?: {
    data?: {
      id: string;
      client_id: string;
      player_id: string;
      device_type: 'all' | 'desktop' | 'mobile';
      channels?: string[];
    };
  };
  deviceType?: DeviceType;
}

export const ConnatixBlock: React.FC<ConnatixVideoProps> = ({ attrs, deviceType }) => {
  const { adLightEnabled, isLoading } = useBenzingaEdge();

  if (!attrs?.data) return null;
  const { channels, client_id, id, player_id } = attrs.data;

  if (attrs?.data?.device_type === 'mobile' && deviceType !== 'mobile') return null;
  else if (attrs?.data?.device_type === 'desktop' && deviceType === 'mobile') return null;
  if (isLoading || adLightEnabled) return null;

  return (
    <ConnatixVideoWrapper className={`${AD_RESERVED_CLASS} w-full`}>
      <React.Suspense fallback={null}>
        <ConnatixInitialHeadScript id={id} />
        <LazyLoad offset={100} once>
          <ConnatixVideoPlayer channels={channels} cid={client_id} id={id} pid={player_id} />
        </LazyLoad>
      </React.Suspense>
    </ConnatixVideoWrapper>
  );
};

export const ConnatixVideoWrapper = styled.div`
  display: block;
  width: 100%;
  margin: 1rem 0;
  overflow: hidden;
  aspect-ratio: 16 / 9;
`;
